import { render, staticRenderFns } from "./AlerteForm.vue?vue&type=template&id=fec4c852"
import script from "./AlerteForm.vue?vue&type=script&lang=ts"
export * from "./AlerteForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports